import React from 'react';
import Link from 'gatsby-link';

import icon from '../assets/images/icon.svg';

const year = new Date().getFullYear();

const Footer = () => (
  <div className="Footer">
    <div className="container">


      <ul className="Footer__links">
        <li className="logoItem">
          <img
            src={icon}
            alt="icon"
            className="logo"
          />
        </li>
        <li>
          <Link to="/pricing">Pricing</Link>
        </li>
      </ul>

      <div className="Footer__bottom">
        <ul className="legal-links">
          <li><Link to="/privacy-policy">Privacy Policy</Link></li>
          <li><Link to="/terms-of-service">Terms of Service</Link></li>
          <li>&copy; {year} RadonEasy</li>
        </ul>
      </div>
    </div>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js